import React from 'react'
import InfoButton from './InfoButton'

// Comparação com o ano anterior: ▲▼ + % + intervalo comparado, ou o texto de quando não há comparação
export const Comparison = ({ comparison }) => {
  if (!comparison) return null
  if (comparison.type === 'note') return <span className='dashboard-delta dashboard-delta-note'>{comparison.text}</span>

  return (
    <span className={`dashboard-delta dashboard-delta-${comparison.tone}`}>
      <span className='dashboard-delta-arrow' aria-hidden='true'>{comparison.arrow}</span>
      <span>{comparison.text}</span>
      {comparison.vs ? <span className='dashboard-delta-vs'>{comparison.vs}</span> : ''}
    </span>
  )
}

// Card de número: rótulo, valor, linha de apoio e comparação (ou uma ação, como "Ver lista").
// info: chave do INDICATOR_INFO (o "i" depois do rótulo)
const KpiCard = ({ label, value, sub, comparison, action, info }) => (
  <div className='dashboard-kpi'>
    <span className='dashboard-kpi-label dashboard-infoline'><span>{label}</span>{info ? <InfoButton indicator={info} /> : ''}</span>
    <strong className='dashboard-kpi-value'>{value}</strong>
    {sub ? <span className='dashboard-kpi-sub'>{sub}</span> : ''}
    <Comparison comparison={comparison} />
    {action || ''}
  </div>
)

export default KpiCard
